const a = [
  "gradient-in",
  "fade-in",
  "slide-in",
  "gradient-sweep",
  "shimmer",
  "none"
], e = ["sm", "md", "lg"], t = {
  sm: {
    characterDelay: 20,
    wordDelay: 30,
    duration: 600
  },
  md: {
    characterDelay: 30,
    wordDelay: 50,
    duration: 1e3
  },
  lg: {
    characterDelay: 50,
    wordDelay: 100,
    duration: 1500
  }
}, n = {
  MOTION_TEXT_ANIMATION_MODES: a,
  MOTION_TEXT_SPEEDS: e,
  MOTION_TEXT_TIMING_PRESETS: t
};
export {
  a as MOTION_TEXT_ANIMATION_MODES,
  e as MOTION_TEXT_SPEEDS,
  t as MOTION_TEXT_TIMING_PRESETS,
  n as default
};
//# sourceMappingURL=motion-text-constants.js.map
